import {
    getBasePrice,
    getFinalPrice,
    getMaximumPrice,
    getMinimalPrice,
    usePrice,
} from '../molecules/catalog/products/price/price.helper';

/**
 * handle use interface ProductInterface
 */
// eslint-disable-next-line
type ProductInterface = any;

export function useCalculatePrices(selectedProduct: ProductInterface) {
    // Safe access to price_range with fallback
    const hasPriceRange = Boolean(selectedProduct?.price_range?.minimum_price?.final_price);

    // Get prices with safe access
    const finalPrice = hasPriceRange ? getFinalPrice(selectedProduct) : null;
    const productBasePrice = hasPriceRange ? getBasePrice(selectedProduct) : null;
    const minimumPrice = hasPriceRange ? getMinimalPrice(selectedProduct) : null;
    const maximumPrice = hasPriceRange ? getMaximumPrice(selectedProduct) : null;

    // Call all hooks unconditionally (React hooks rules)
    const { price, basePrice, discount } = usePrice({
        amount: finalPrice?.value ?? 0,
        baseAmount: productBasePrice?.value ?? 0,
        currencyCode: finalPrice?.currency ?? 'VND',
    });

    const { price: minPrice } = usePrice({
        amount: minimumPrice?.value ?? 0,
        currencyCode: minimumPrice?.currency ?? 'VND',
    });

    const { price: maxPrice } = usePrice({
        amount: maximumPrice?.value ?? 0,
        currencyCode: maximumPrice?.currency ?? 'VND',
    });

    return {
        maximumPrice: maximumPrice ?? { value: 0, currency: 'VND' },
        minimumPrice: minimumPrice ?? { value: 0, currency: 'VND' },
        minPrice,
        maxPrice,
        discount,
        basePrice,
        price,
    };
}
